  <div class="p-3 mb-4 bg-light rounded-3">
  <div class="mb-4 row">
    <div class="col-12 mb-3">
        <div class="titletoptables">
          <div class="leftsideicons">
            <img src="../../assets/image/Report-icon.png" alt="report" onkeydown=""/>
          </div>
          <h3>Reports</h3>
        </div>
      </div>
    </div>
     <table class="table table-bordered table-hover report-table">
        <thead>
            <tr>
                <th scope="col">#</th>
                <th scope="col">
                    <h5 class="table-header">Action</h5>
                </th>
                <th scope="col">
                    <h5 class="table-header">Report Name</h5>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr class="report-table-row" (click)="navigateToReports(report)"
                *ngFor="let report of dropdownValues;let i = index">
                <th scope="row">{{i+1}}</th>
                <td> <img src="../../assets/image/view-icon.png" class="ico20" /></td>
                <td>
                    <h6>{{ report.Name }}</h6>
                </td>
            </tr>
        </tbody>
    </table>
  </div>
